import { UserNotificationUtilService, UserNotification } from "@scisys-uim/uim-common";
import { TRANSFER_ASSET_TYPE } from "assets-model";

export class TransferAssetNotificationUtilService implements UserNotificationUtilService {

  unableToDismissReason(notification?: UserNotification): string {
    return ""
  }

  canBeDismissed(notification: UserNotification): boolean {
    return true;
  }

  getUserMessageType(): string {
    return "TransferAssetAction";
  }

  getRouteFromLinkData(notification: UserNotification): any[] {
    return ['/transferasset/edit', notification.linkData.id];
  }

  getRouteLinkQueryParams(notification: UserNotification) {
  }

}
